import Vue from "vue";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "./styles/theme.css";
import App from "./App";
// import 'babel-polyfill'
import moment from "moment";
import COMMONDATA from "@oos/utils/CommonData.js";
// import echarts from 'echarts'
import * as echarts from "echarts";
Vue.prototype.$echarts = echarts;

Vue.prototype.$keep8Bits = function(bit) {
  if (bit.length > 8) {
    return bit.slice(bit.length - 8).replace(/\b(0+)/gi, "");
  } else {
    return bit.replace(/\b(0+)/gi, "");
  }
};

Vue.prototype.$mergeHandler = function(arr, sn) {
  arr.forEach(item => {
    if (item[sn] == null || !item.prefixSn) {
      item[sn] = "";
    } else {
      item[sn] = item.prefixSn + "" + item[sn];
    }
  });
  return arr;
};

Vue.prototype.$COMMONDATA = COMMONDATA;

Vue.config.productionTip = false;
Vue.use(ElementUI, { size: "small" });

import VueRouter from "vue-router"; //引入路由
Vue.use(VueRouter); //安装 （内部实现：注册组件到全局）
import routes from "./router/index";

let router = new VueRouter({
  ...routes
}); //创建路由对象

router.beforeEach((to, from, next) => {
  window.document.title = "仟信管理台";
  if (to.path == "/login") {
    localStorage.getItem("kposToken");
  }
  let kposToken = localStorage.getItem("kposToken");
  if (!kposToken && to.path != "/login") {
    next({ path: "/login" });
  } else {
    next();
  }
});

//时间过滤器
Vue.filter("dateDaily", function(time) {
  if (time) {
    return moment(time, "YYYYMMDD").format("YYYY-MM-DD");
  } else {
    return "";
  }
});
//时间过滤器
Vue.filter("dateAllTime", function(time) {
  if (!time) {
    return "";
  }
  const s = String(time).trim();
  if (/^\d{12}$/.test(s)) {
    return moment(s, "YYYYMMDDHHmm").format("YYYY-MM-DD HH:mm:ss");
  }
  if (/^\d{14}$/.test(s) && s.indexOf(":") === -1) {
    return moment(s, "YYYYMMDDHHmmss").format("YYYY-MM-DD HH:mm:ss");
  }
  const m = moment(s, ["YYYYMMDDHH:mm:ss", "YYYY-MM-DD HH:mm:ss", moment.ISO_8601], true);
  return m.isValid() ? m.format("YYYY-MM-DD HH:mm:ss") : s;
});

//数据处理 相乘
Vue.filter("dataMultiply", function(data) {
  if (data) {
    return parseFloat((data * 100).toPrecision(12));
  } else {
    return data;
  }
});
//数据处理 相除
Vue.filter("dataDivide", function(data) {
  if (data) {
    return data / 100;
  } else {
    return data;
  }
});

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/oos/main.js